import "./Order.css"
import Product1 from "../Components/Product1"
import Alexa from "../images/alexa.jpg"
import Laptop1 from "../images/lp1.jpg"
import Laptop2 from "../images/lp2.jpg"
import Laptop3 from "../images/lp3.jpg"
import Laptop4 from "../images/lp4.jpg"
import Laptop5 from "../images/lp5.jpg"
import Laptop6 from "../images/lp6.jpg"
import Laptop7 from "../images/lp7.jpg"
import Laptop8 from "../images/lp8.jpg"
export default function Order() {

  return (
    <div className="stdivinhome">
      <div className="home">

        <div className="home__prd">

          <div className="home__prd1">

            <Product1  prdName="Dell i5" img={Laptop1} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
              <Product1 prdName="Dell i7" img={Laptop2} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>          

          </div>

          <div className="home__prd1">

          
          <Product1 prdName="Hp i7" img={Laptop3} price="Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 prdName="Hp i5" img={Laptop4} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
        

          </div>

        </div>


        <div className="home__prd">

          <div className="home__prd1">

            <Product1 prdName="Mack book " img={Laptop5} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"  ></Product1>
            <Product1 prdName="Mackbook 2" img={Laptop6} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

          <div className="home__prd1">

            <Product1 prdName="Mack book pro" img={Laptop7} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>
            <Product1 prdName="Mack book pro" img={Laptop8} price=" Price : ₹ 5580" review="5.5" buttonCart="Add to cart"></Product1>

          </div>

        </div>

      </div>

    </div>
  )
}
//Dell Inspiron 3501 15.6" FHD Display Laptop (i3-1115G4 / 4GB / 512GB SSD / Integrated Graphics / Win 10 + MSO / Backlit KB / Soft Mint)
//Dell Inspiron 3505 15.6" FHD Display Laptop (Ryzen 5 -3450U / 8GB / 1TB + 256Gb SSD / Vega 8 Graphics / Win 10 + MS Office / Soft Mint Color)

//HP 15 (2021) Thin & Light Ryzen 3-3250 Laptop, 8 GB RAM, 1TB HDD, 39.62 cms (15.6") FHD Screen, Windows 10, MS Office (15s-gr0011AU)
//HP 15 (2021) Thin & Light Ryzen 5 3500U Laptop, 8GB RAM, 512GB SSD, 39.62 cms (15.6") FHD Screen, Windows 10, MS Office, Natural Silver (15s-gr0500AU)


//2020 Apple MacBook Pro (13.3-inch/33.78 cm, 8GB RAM, 256GB SSD, 1.4GHz Quad-core 8th-Generation Intel Core i5 Processor, Two Thunderbolt 3 Ports) - Space Grey
//2019 Apple MacBook Pro (16-inch/40.65 cm, 16GB RAM, 1TB Storage, 2.3GHz 9th Gen Intel Core i9) - Space Grey
//2020 Apple MacBook Pro (13.3-inch/33.78 cm, Apple M1 chip with 8‑core CPU and 8‑core GPU, 8GB RAM, 512GB SSD) - Silver
//2020 Apple MacBook Air (13.3-inch/33.78 cm, Apple M1 chip with 8‑core CPU and 7‑core GPU, 8GB RAM, 256GB SSD) - Gold